import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {mbeConfigService} from './mbe-config.service';
import { Observable } from 'rxjs';
import {DocumentationListAPI, IDocumentationList} from '../..';
import {BasicResponse} from '@auth-suite-services/services';

@Injectable({
  providedIn: 'root'
})
export class DocumentationListService {

  private URL;
  headers: HttpHeaders;

  // See C001 - 2026-09-07 - HE
  // constructor(@Inject(mbeConfigService) private config, private httpClient: HttpClient) {
  //   this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'MBE').url;
  constructor(@Inject(mbeConfigService) private config: any, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find((restUrl: { api?: string; url?: string }) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getAllDLI(pageIndex: number, pageSize: number, sortActive: string, sort: string): Observable<DocumentationListAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<DocumentationListAPI>(`${this.URL}/dli/getalldli/${pageIndex}/${pageSize}/${sortActive ? sortActive : 'id'}/${sort ? sort : 'asc'}`, {headers});
  }

  getDLI(id: number) {
    console.log('ID');
    console.log(id);
    const headers = this.headers;
    return this.httpClient.get<IDocumentationList>(`${this.URL}/dli/getdli/${id}`, {headers});
  }

  updateDLI(DLI: IDocumentationList): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update bfd: ' + JSON.stringify(DLI));
    return this.httpClient.post<BasicResponse>(`${this.URL}/dli/updatedli`, DLI, {headers});
  }

  createDLI(DLI: IDocumentationList): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update bfd: ' + JSON.stringify(DLI));
    return this.httpClient.post<BasicResponse>(`${this.URL}/dli/createdli`, DLI, {headers});
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Typed DocumentationListService constructor config as any and REST_SERVER_url.find restUrl as { api?: string; url?: string }. Previous behavior: constructor parameters were untyped (implicit any), which failed Jest/ts-jest under noImplicitAny when DocumentationListService.spec.ts imported the service for AM ISSUE C HTTP tests. New behavior: config and restUrl have explicit types so the spec compiles. Reason: Enable AM ISSUE C unit tests for FrontEnd Username on GET /dli/getalldli and /dli/getdli. Context: Same InjectionToken pattern as SourceService/FinancialService. Impact: Runtime URL construction unchanged. - 2026-09-07 - HE
